export const FormataData = (data, hora = false) => {
    if (!(data instanceof Date)) {
        data = new Date(data);
    }

    const pad = (num, size = 2) => String(num).padStart(size, '0');

    const dia = pad(data.getDate());
    const mes = pad(data.getMonth() + 1);
    const ano = pad(data.getFullYear(), 4);

    if (!hora) {
        return `${dia}/${mes}/${ano}`;
    }

    const horas = pad(data.getHours());
    const minutos = pad(data.getMinutes());
    const segundos = pad(data.getSeconds());

    return `${dia}/${mes}/${ano} ${horas}:${minutos}:${segundos}`;
};

export const FormataDataBrToEng = (data, hora = false) => {

    if (!(data instanceof Date)) {
        data = new Date(data);
    }

    const pad = (num, size = 2) => String(num).padStart(size, '0');

    const dia = pad(data.getDate());
    const mes = pad(data.getMonth() + 1);
    const ano = pad(data.getFullYear(), 4);

    if (!hora) {
        return `${ano}-${mes}-${dia}`;
    }

    const horas = pad(data.getHours());
    const minutos = pad(data.getMinutes());
    const segundos = pad(data.getSeconds());

    return `${ano}-${mes}-${dia}T${horas}:${minutos}:${segundos}`;
}